export const environment = {
  production: false,
  DOMAIN_URL: process.env.DOMAIN_URL,
  API_SECRET_KEY: process.env.API_SECRET_KEY,
  AUTH_URL: process.env.AUTH_URL,
  YOUTUBE_API_KEY: process.env.YOUTUBE_API_KEY,
  WIDGETS_KEY: process.env.WIDGETS_KEY,
  QUIZ_URL: process.env.QUIZ_URL,
}